module.exports = __webpack_public_path__ + "static/img/05.77bd5f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour1/05.jpg
// module id = yrrw
// module chunks = 0